<div class="message-video" *ngIf="message != null">
    <ng-container *ngIf="(message.attachments ?? message.files).length > 0 else novideo">
        <!-- message has no files -->
        <header [hidden]="(message.attachments ?? message.files).length == 0">
            <h4 *ngIf="show" (click)="toggleAttachments()"><em>{{(message.attachments ?? message.files).length}}</em> <span class="arrow-up">Attachment{{(message.attachments ?? message.files).length > 1 ? 's':''}}</span></h4>
            <h4 *ngIf="!show" (click)="toggleAttachments()"><em>{{(message.attachments ?? message.files).length}}</em> <span class="arrow-down">Attachment{{(message.attachments ?? message.files).length > 1 ? 's':''}}</span></h4>
        </header>
        <div [hidden]="!show">
            <core-files-list-default-item
                [file]="(message.attachments ?? message.files)[0]"
                [menu]="menu"
                (menuClick)="onMenuClick($event)"
                (actionClick)="openVideo($event)"
            ></core-files-list-default-item>
        </div>
        <div *ngIf="selectedFile" class="message-video-container">
            <video controls="true">
                    <source [src]="videoSrc">
                    Your browser does not support HTML5 video.
            </video>
        </div>
    </ng-container>
    <ng-template #novideo>
        <core-helpers-box-alert-message-icon
            [text]="'There are no video attached.'"
            [icon]="'no_messages'"
        ></core-helpers-box-alert-message-icon>
    </ng-template>

</div>
